import TiptapColor from "@tiptap/extension-color";

import ColorActionButton from "../../extensions/Color/components/ColorActionButton";

export const Color = TiptapColor.extend({
	addOptions() {
		return {
			...this.parent?.(),
			button({ editor, t, extension }) {
				return {
					component: ColorActionButton,
					componentProps: {
						colors: extension.options.colors,
						defaultColor: extension.options.defaultColor,
						action: color => {
							if (color === undefined) {
								editor.chain().focus().unsetColor().run();
							}
							if (typeof color === "string") {
								editor.chain().focus().setColor(color).run();
							}
						},
						isActive: () => {
							const { color } = editor.getAttributes("textStyle");
							if (!color) {
								return false;
							}
							return editor.isActive({ color }) || false;
						},
						editor,
						tooltip: t("editor.color.tooltip")
					}
				};
			}
		};
	}
});
